import { Skeleton } from "../ui/skeleton";

export default function SectionLoader() {
  return (
    <div>
      <div className="grid grid-cols-3 gap-1">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="relative h-[500px] bg-midnightIndigo-100">
            <div className="absolute p-4 bottom-5">
              <Skeleton className="w-36 mb-2 h-8 bg-midnightIndigo-200" />
              <Skeleton className="w-64 h-6 bg-midnightIndigo-200" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
